import React from "react";
import { ExternalLink, X } from "react-feather";
import { IconButton } from "../IconButton";

type ExternalLinkDisplayProps = {
  onRemove?: () => void;
  title: string;
  url: string;
  children?: React.ReactNode;
};

export const ExternalLinkBox: React.FC<ExternalLinkDisplayProps> = ({
  onRemove,
  title,
  url,
  children,
}) => {
  return (
    <div
      className="mt-2 flex w-full max-w-full flex-col rounded-md border border-gray-300 bg-gray-50 p-0 outline-1 focus:outline-blue-600"
      tabIndex={0}>
      <div className="flex w-full items-center justify-between gap-4 bg-gray-100 p-2">
        <p className="truncate text-sm">{title}</p>
        <div className="flex items-center gap-2">
          {onRemove && (
            <IconButton onClick={onRemove}>
              <X />
            </IconButton>
          )}
          <IconButton onClick={() => window.open(url, "_blank")}>
            <ExternalLink />
          </IconButton>
        </div>
      </div>
      {children}
    </div>
  );
};
